import { createContext, Component } from 'react'

import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Location } from 'history'

const HistoryContext = createContext({} as Location)

class LocationProvider extends Component<RouteComponentProps & { children?: any }, { location: Location }> {
  state = { location: this.props.location }

  componentDidUpdate(prevProps: RouteComponentProps) {
    const { location } = prevProps
    if (location.pathname !== this.props.location.pathname) {
      this.setState({ location })
    }
  }

  render() {
    return <HistoryContext.Provider value={this.state.location}>{this.props.children}</HistoryContext.Provider>
  }
}

export default withRouter(LocationProvider)
export { HistoryContext }
